import { charsPerLine } from '@/features/print/constants'

export const getCharsPerLineOptions = () =>
    charsPerLine.reduce<{ [value: string]: string }>((options, charsPerLine) => {
        options[charsPerLine.toString()] = charsPerLine.toString()
        return options
    }, {})
